const clientCommission = import.meta.env.VITE_CLIENT_COMMISSION
const providerCommsion = import.meta.env.VITE_PROVIDER_COMMISSION
import { termOfUseEn } from './termOfUse_en.js'
import { faqEn } from './faq_en.js'
import { whatMovesUsEn } from './whatMovesUs_en.js'
import { privacyPolicyEn } from './privacyPolicy_en.js'
import { textMessagePolicyEn } from './textMessagePolicy_en.js'
import { legalAgreementsContactEn } from './legalAgreementsContact_en.js'
export const englishTranlation = {
    "footer_phoneLabel": "Phone: {{phone}}",
    "footer_call": "Call",
    "footer_copy": "Copy",
    "myProfile": "My Profile",
    'stripeDashboard':'Stripe Dashboard',
    "stripeOnbaord":"Stripe Onboarding",
    "panel": "Panel",
    "messages": "Messages",
    "ClientGuidance":"Guidance Center — Clients",
    "ProviderGuidance":"Provider Guidance",
    "providerGuidance_tab1_title": "What is required to be a provider on Jandi?",
    "providerGuidance_tab1_intro": "To activate your profile and start receiving requests you must complete the professional validation process. This process ensures trust, security and structure within the platform.",
    "providerGuidance_tab1_mandatoryTitle": "What documents are required for everyone?",
    "providerGuidance_tab1_mandatory": "All providers must upload:\n✔ Valid Certificate of Good Conduct\n✔ Official photo ID\nThese documents are used only for internal validation and are not publicly visible.",
    "providerGuidance_tab1_otherDocsTitle": "What other documents may be required?",
    "providerGuidance_tab1_otherDocs": "Depending on your service category, the following may be required:\n• Professional licenses\n• Technical certifications\n• Specific permits\nIf your category requires a license, your profile will not be visible until the document is approved.",
    "providerGuidance_tab1_profileTitle": "What information should my profile include?",
    "providerGuidance_tab1_profile": "• Professional photo (per Official Photography Guide)\n• Clear description of experience\n• Service categories\n• Geographic area\n• Updated availability\n• Payment method (Stripe and/or ATH Móvil)\nEstimated validation time: 24–48 business hours.\nYour profile will not be visible until approved.",
    "providerGuidance_tab1_photoTitle": "What should my profile photo look like?",
    "providerGuidance_tab1_photoDo": "It should be:\n✔ Individual portrait\n✔ Clear, tidy background\n✔ Face visible and looking at camera\n✔ Good lighting\n✔ Sharp image",
    "providerGuidance_tab1_photoDont": "Avoid:\n✘ Group photos\n✘ Filters\n✘ Sunglasses\n✘ Informal selfies\n✘ Cluttered backgrounds",
    "providerGuidance_tab1_photoNote": "A professional image increases the likelihood of bookings.",
    "providerGuidance_tab2_title": "How does Jandi work when I receive a request?",
    "providerGuidance_tab2_whereTitle": "Where do I see new requests?",
    "providerGuidance_tab2_where": "When a client requests a quote you will receive a notification by email and text message. You can see the request within the platform in:\nMessages → Chats\nIn the chat you can review the details of the requested service and respond with your proposal.",
    "providerGuidance_tab2_timeTitle": "How soon should I respond?",
    "providerGuidance_tab2_time": "It is recommended to respond within a reasonable time to show interest. Usually within 8 hours, at least to start the conversation. If no communication is started with the client within that time, the system may reassign the request to another available provider to ensure the client receives timely attention.\nResponding quickly increases the likelihood of confirmation.",
    "providerGuidance_tab2_notifTitle": "How do I receive notifications?",
    "providerGuidance_tab2_notif": "Whenever activity related to your service occurs you will receive notifications. These notifications are sent via:\n• email\n• text message\nYou will receive notifications when:\n• you receive a new request\n• the client sends a message\n• a service is confirmed\n• the service status changes\n• a cancellation occurs\nThese alerts help you keep track of the process.",
    "providerGuidance_tab2_coordTitle": "Where do I coordinate the service?",
    "providerGuidance_tab2_coord": "Service coordination takes place within:\nMessages\nThere you agree with the client:\n• date\n• time\n• scope of work\n• final price",
    "providerGuidance_tab2_chatTitle": "Why is it important to use the internal chat?",
    "providerGuidance_tab2_chat": "The chat:\n• keeps an official record of the agreement\n• activates support in case of dispute\n• creates traceability\n• protects your reputation\nConversations outside the system do not activate protection within the platform.",
    "providerGuidance_tab3_title": "What happens step by step during a service?",
    "providerGuidance_tab3_step1Title": "1. The client confirms the service",
    "providerGuidance_tab3_step1": "The client reviews your proposal, presses Confirm service and enters their payment method. The amount is authorized at that time, but is only processed when the service is marked as completed within the platform.",
    "providerGuidance_tab3_step2Title": "2. Mark “I’ve arrived” (required step)",
    "providerGuidance_tab3_step2": "When you arrive at the service location press:\nMark as arrived\nThis step:\n• notifies the client\n• officially records your arrival\n• activates the service flow within the system\n⚠️ Important:\nIf the provider does not mark “I’ve arrived”, the system does not enable the “Job complete” option for the client. That is why it is important to mark arrival when starting the service.",
    "providerGuidance_tab3_step3Title": "3. Perform the service",
    "providerGuidance_tab3_step3": "Carry out the work as agreed in Messages.",
    "providerGuidance_tab3_step4Title": "4. The client marks “Job complete”",
    "providerGuidance_tab3_step4": "When the work is finished, the client will press:\nJob complete\nThis step:\n• officially closes the service\n• activates payment processing\n• records the transaction\n• allows the review\nIf the client does not mark “Job complete”, the service remains open in the system.",
    "providerGuidance_tab3_step5Title": "5. Create dispute (if a problem occurs)",
    "providerGuidance_tab3_step5": "Both the provider and the client have the option to:\nCreate dispute\nThis allows the Jandi team to review the case using:\n• service history\n• recorded messages\n• service statuses\nThat is why it is important to keep communication within the system.",
    "providerGuidance_tab3_step6Title": "6. Where do I see my payments?",
    "providerGuidance_tab3_step6": "In:\nPayment history\nYou can also check details in your payments panel.",
    "providerGuidance_tab4_title": "How do payments and cancellations work?",
    "providerGuidance_tab4_whenPaidTitle": "When do I receive payment?",
    "providerGuidance_tab4_whenPaid": "The client authorizes the amount when they confirm the service. Payment is processed when the client marks “Job complete” and is reflected within 24–48 hours depending on the process with your bank. When Stripe generates the transaction you will receive a text message.",
    "providerGuidance_tab4_clientCancelTitle": "What happens if the client cancels within 24 hours?",
    "providerGuidance_tab4_clientCancel": "A cancellation fee will apply in accordance with Jandi’s cancellation policy.",
    "providerGuidance_tab4_providerCancel24Title": "What happens if I cancel a confirmed service with more than 24 hours’ notice?",
    "providerGuidance_tab4_providerCancel24": "There is no automatic financial penalty. However, the cancellation is recorded in the provider’s history.",
    "providerGuidance_tab4_providerCancelWithinTitle": "What happens if I cancel within 24 hours of the service?",
    "providerGuidance_tab4_providerCancelWithin": "The cancellation will have a greater impact on your history within the platform. Repeated cancellations may result in temporary account suspension.",
    "providerGuidance_tab4_reputationTitle": "Why does it affect my reputation?",
    "providerGuidance_tab4_reputation": "Because Jandi operates on scheduled commitment. When a service is confirmed:\n• the schedule is blocked\n• a digital contractual relationship is activated\nFulfillment is part of the professional standard. Jandi protects time as an economic asset.",
    "providerGuidance_tab4_multiProviderTitle": "Can the client request multiple providers?",
    "providerGuidance_tab4_multiProvider": "Yes. The client can send requests to more than one provider to compare proposals. Responding quickly increases the likelihood of confirmation.",
    "providerGuidance_tab5_title": "What standards must I maintain as a provider?",
    "providerGuidance_tab5_standards": "• Punctuality\n• Professional communication\n• Fulfillment of agreements\n• Using the system to coordinate services",
    "providerGuidance_tab5_platformOnly": "Only services managed within the platform:\n• activate secure payment\n• generate digital history\n• allow support in disputes\n• build verifiable reputation",
    "providerGuidance_tab6_title": "What is the legal relationship and how is my information protected?",
    "providerGuidance_tab6_contractor": "• You are an independent contractor\n• There is no employment relationship with Jandi\n• You are responsible for your licenses and tax compliance",
    "providerGuidance_tab6_payments": "Payments are processed through Stripe. Text message notifications are activated when you accept the legal policies.",
    "providerGuidance_tab6_docs": "See the full documents at:\nwww.jandipr.com",
    "clientGuidance_tab1_title": "How does Jandi work?",
    "clientGuidance_tab1_intro": "Jandi connects clients with independent service providers in Puerto Rico. Through the platform you can:\n• request quotes\n• communicate with providers\n• confirm services\n• authorize payments securely\nWhen the service ends you must mark Job complete to close the transaction.",
    "clientGuidance_tab1_stepsTitle": "What steps do I follow to hire a service?",
    "clientGuidance_tab1_steps": "Request the service within the platform.\nReview the proposals received in My proposals.\nOpen the proposal and review the details.\nPress Confirm service.\nAuthorize the payment.\nThe service will be scheduled within the platform.",
    "clientGuidance_tab1_multiTitle": "Can I request a quote from multiple providers?",
    "clientGuidance_tab1_multi": "Yes. You can send requests to different providers to compare:\n• price\n• availability\n• experience\nThis allows you to choose the option that best fits your needs.",
    "clientGuidance_tab2_title": "How do payments and transactions work?",
    "clientGuidance_tab2_when": "When you confirm a service, the payment is authorized but not charged immediately. The charge is only processed when the service is marked as completed within the platform. This protects both the client and the provider.",
    "clientGuidance_tab2_completeTitle": "Why should I mark the service as completed?",
    "clientGuidance_tab2_complete": "Marking Job complete:\n• releases the payment to the provider\n• closes the transaction\n• enables the service review\nIf it is not marked as completed, the system understands that the service is still open.",
    "clientGuidance_tab2_platformTitle": "Why should I pay within the platform?",
    "clientGuidance_tab2_platform": "When payment is made within Jandi:\n• the transaction is recorded\n• the payment is processed securely\n• there is a service history\n• Jandi can provide support if any issue arises\nIf payment is made outside the platform, Jandi cannot guarantee backup or assistance.",
    "clientGuidance_tab3_title": "What is the process with the provider during a service?",
    "clientGuidance_tab3_step1Title": "1. The provider marks “I’ve arrived”",
    "clientGuidance_tab3_step1": "When the provider arrives at the service location they will mark:\nMark as arrived\nThis officially records the provider’s arrival in the system.\n⚠️ Important:\nUntil the provider marks “I’ve arrived”, the system does not enable the “Job complete” option.",
    "clientGuidance_tab3_step2Title": "2. Communication during the service",
    "clientGuidance_tab3_step2": "Use the chat within Jandi to coordinate service details and keep the conversation history. If both parties wish, they can exchange phone numbers and communicate through other means by mutual agreement. However, Jandi can only provide support based on the information recorded within the platform.",
    "clientGuidance_tab3_step3Title": "3. Complete service: Job complete",
    "clientGuidance_tab3_step3": "When the work is finished and satisfactory, press:\nJob complete\nThis:\n• closes the service\n• releases the payment to the provider\n• enables the service review\nIf the service is not marked as completed, the transaction will remain open in the system.",
    "clientGuidance_tab3_step4Title": "4. Create dispute",
    "clientGuidance_tab3_step4": "If any issue arises during the service:\n• you can contact the provider through the chat\n• you can select Create dispute\nThis allows the Jandi team to review the case using the information recorded within the platform.",
    "clientGuidance_tab4_title": "What happens if I need to cancel or have a problem?",
    "clientGuidance_tab4_cancel24Title": "What happens if I cancel with more than 24 hours’ notice?",
    "clientGuidance_tab4_cancel24": "If you cancel with more than 24 hours’ notice, no charge will apply.",
    "clientGuidance_tab4_cancelWithinTitle": "What happens if I cancel within 24 hours before the service?",
    "clientGuidance_tab4_cancelWithin": "If you cancel within 24 hours before the service, a cancellation fee equivalent to 15% of the total value of the confirmed service will apply. This policy protects the time reserved by the provider.",
    "clientGuidance_tab4_problemTitle": "What happens if there is a problem with the service?",
    "clientGuidance_tab4_problem": "If any issue arises:\n• you can contact the provider through the chat\n• you can create a dispute within the platform\nThe Jandi team can review the case and provide support according to the information recorded in the system. That is why it is important to keep communication within the platform.",
    "clientGuidance_tab5_title": "How does my account work within Jandi?",
    "clientGuidance_tab5_smsTitle": "Why do I receive text message notifications?",
    "clientGuidance_tab5_sms": "Jandi uses notifications to keep you informed about the status of the service. You will receive notices when:\n• a request is confirmed\n• you receive a new message\n• the service status changes\n• the provider marks that they are on the way or have arrived\n• a cancellation occurs\nThese notifications help you keep track of the scheduled service.",
    "clientGuidance_tab5_trustTitle": "How do we know that providers are trustworthy?",
    "clientGuidance_tab5_trust": "Providers who are part of Jandi go through a verification process that may include:\n• identity verification\n• certificate of good conduct\n• professional licenses or certifications when applicable\nThis helps build a more trustworthy community.",
    "clientGuidance_tab5_reviewTitle": "How do I leave a review?",
    "clientGuidance_tab5_review": "Once the service is completed you can rate your experience and leave comments about the work performed. Reviews help maintain quality standards and guide other clients within the platform.",
    "clientGuidance_tab5_behaviorTitle": "What behavior is expected within the platform?",
    "clientGuidance_tab5_behavior": "Jandi promotes a community based on respect. Clients and providers are expected to maintain:\n• clear communication\n• courteous treatment\n• responsible use of the platform\nJandi reserves the right to limit or suspend accounts in cases of misuse or inappropriate behavior.",
    "help": "Help",
    "helpTitle": "Help",
    "helpIntro": "If you need support from the Jandi team or have any questions about how the platform works, you can contact us.",
    "helpSupportTitle": "Jandi team support",
    "helpEmail": "Email:",
    "helpPhone": "Phone or text:",
    "helpDisputes": "For matters related to a specific service between client and provider, use the “Disputes” button within the panel.",
    "helpMore": "You can also find more information and educational material at:\nwww.jandipr.com and our social media.",
    "settings": "Settings",
    "logout": "Logout",
    "Type":"Type",
    "of":"of",
    "C/R":"Cancelled/Refunded",
    "totalCharge":"Total to pay",
    "provider_platform_fee":"Provider Platform Fee",
    "client_platform_fee":"Client Platform fee",
    'alwaysAtHand':"Always at hand",
    "budgetDetails":"Budget Details",
    "enterBudgetDetails":"My budget range is $500-$1000, looking for competitive pricing...",
    "noDescriptionAvailable":"No Description Available",
    "skillsRequired":"Skills Required",
    "availableProviders":"Available Providers",
    "share": "Share",
    "Buscar": "Search",
    "Buscando...": "Searching...",
    "RequestQuote":"Request Quote",
    "requestAQuote":"Request Quote",
    "sendQuoteRequest": 'Send Quote Request',
    "reviewQuoteRequest":"Review Quote Request",
    "reviewAndConfirm":"Review & Confirm",
    "requestSummary":"Request Summary",
    "serviceType":"Service Type",
    "selectedProfessionals":"Selected Professionals",
    "professionalsWillRespond":"These professionals will review your request and respond with quotes shortly.",
    "sendRequest":"Send Request",
    "quoteRequestNote":"Please review your quote request before sending it to the professional.",
    "sendingQuoteRequest":"Sending Request Quote",
    "continueToReview":"Continue to review",
    "saveQuoteDetails":"Save quote details",
    "quoteDetailsSaved":"Quote details saved. Choose providers, then continue.",
    "quoteDetails":"Quote details",
    "selectProviders":"Providers",
    "selected":"Selected",
    "maxProvidersSelected":"You can select up to 3 providers.",
    "mustSelectProvider":"Please select at least one provider.",
    "completeQuoteFormFirst":"Please complete the quote form first.",
    "noProfessionalsFound":"No providers found for these filters.",
    "autoSendNearby":"Auto-send to nearby providers (up to 3 within 50 km)",
    "selectUpTo3Providers":"Select up to 3 providers",
    "autoSendToNearbyProviders":"Auto-send to nearby providers",
    "newServiceRequest":"New Service Request",
    "fillDetailsToFindPros":"Fill out the details below to find the best professional for your project.",
    "findProfessionals":"Find Professionals",
    "chooseProfessionals":"Choose Professionals",
    "selectUpTo3Experts":"Select up to 3 experts to quote your project",
    "step1Of3Details":"STEP 1 OF 3: DETAILS & SELECTION",
    "requestDetails":"Request Details",
    "availableProfessionals":"Available Professionals",
    "professionalsSelected":"Professionals Selected",
    "chooseUpTo3ForQuotes":"Choose up to 3 for quotes",
    "estRate":"Est. Rate",
    "addPhotosOptional":"Add Photos (Optional)",
    "requestSecureNote":"Your request is secure. Professionals are verified and vetted.",
    "chooseLocationOnMap":"Choose location on map",
    "description_required":"Please add a description.",
    "something_went_wrong":"Something went wrong.",
    "cannotSendProposalToYourself":"You cannot send a proposal to yourself.",
    "remote":"Remote",
    "details":"Details",
    "providers":"Providers",
    "quoteConvertedTitle":"Quote converted to a job",
    "quoteConvertedToJob":"This quote request was accepted and converted into a job. You can no longer edit a proposal here.",
    "viewMyJobs":"View my jobs",
    "requestQuoteJobNotFound":"Unable to load this quote request.",
    "proposalAcceptedReadOnly":"This proposal was accepted. Editing is disabled.",
    "proposalRejectedReadOnly":"This proposal was rejected. Editing is disabled.",

"checkOutThisWorkerProfile": "Check out this worker's profile",
"linkCopiedToClipboard": "Profile link copied to clipboard!",
"couldNotShareProfile": "Could not share the profile",
'metadataTags':'Metadata tags',
    "GoToStripeOnboarding":"Go to Stripe Onboarding",
    "offerMyService": "Offer service",
    "iNeedAService": "I need service",
    "serviceArea": "Service Area",
    "selectArea":"Select area(s)",
    "whereDoYouNeed":"Where do you need it?",
    "selectServiceAreas": "Select Service Area/s",
    "clean": "Clean",
    "servicesOffered": "What service do you need?",
    "searchDescribeNeed": "Describe what you need (e.g. 'Math tutor near Condado available Saturdays')...",
    "searchDescribeWhatYouNeed": "Describe what you need",
    "searchByCategoryArea": "By Category & Area",
    "searchPopular": "Popular:",
    "popularApCalculus": "AP Calculus tutor",
    "popularUrgentElectrical": "Urgent electrical repair",
    "popularDeepCleaning": "Deep house cleaning",
    "popularGardenLandscaping": "Garden landscaping",
    "searchAiBadge": "AI",
    "selectServiceOffered": "What service do you need?",
    "advancedSearch": "Advanced Search",
    "chooseMoreOptions": "Choose more options",
    "priceRange": "Price range",
    "minimumQualification": "Minimum qualification",
    "noDataAvailableAgainstFilters": "No data available against the applied filters!",
    "otherRegionsProvidersAvailable": "Here are providers from other regions.",
    "hireElectricianTrusted": "Hire a trusted", 
    "trustedTask":"for the task you need.",
    "hireAProfessional": "HIRE A PROFESSIONAL",
    "review": "Review",
    "reviews": "Reviews",
    "CommissionNote":`An ${providerCommsion}% commission will be charged on your total earnings along with this job.`,
    "CommissionExample":"Example: The total job payment is $100. An 8% commission will be applied, so your net earnings will be $92.",
    "CommissionNote17":`A ${clientCommission}% commission including tax will be added to the total amount for this job.`,
    "CommissionExample17":"Example: If the base job payment is $100, a 17% commission will be applied, bringing the total charge to $117.",
    "CommissionAmount":"Total Amount After Commission",    
    "login": "Login",
    "bestProfessionalsNearYou": "The best", 
    "professionals": "professionals",
    "nearYou": "near you",
    "noReviewsYet": "This provider has no reviews yet. Be the first!",
    "viewProfile": "View Profile",
    "findUsAlsoHere": "Find us also here",
    "iWantToOfferMyServices": "I want to offer my services",
    "availableServices": "Available Services",
    "iNeedAServiceAgain": "I need a service",
    "discoverJandi": "Discover Jandi",
    "copyright": "Jandi PR. All rights reserved.",
    "whatMovesUs": "What moves us",
    "frequentlyAskedQuestions": "Frequently Asked Questions",
  "hireAProfessional": "HIRE A PROFESSIONAL",
  "aboutJandi": "At JANDI, we make connections happen in a simple, safe, and professional way. Our vision is that those looking for a service can easily find, hire safely, and resolve with JANDI, without complications. Our mission is that those offering their services have a reliable space to work, get paid securely, and grow with JANDI. Every experience counts. That’s why our rating system strengthens trust, and geolocation allows you to connect with someone nearby, right when you need it. What moves us is building community: a space where local talent, efficiency, and collaboration coexist so that everything works better, together.",
  "contactUs": "Contact us",
 "contactDescription": "At Jandi we are <strong>#AlwaysAtHand.</strong> We want your experience to be simple, secure, and hassle-free. Tell us how we can help you, and our team will respond as soon as possible.<br> If you need support, have an idea or want to share your feedback, write to us at <strong><a href=\"mailto:hola@jandipr.com\">hola@jandipr.com</a></strong>. We'd love to hear from you!",
  "userEmail": "User email",
  "password": "Password",
  "rememberMe": "Remember me",
  "forgotPassword": "Forgot your password?",
  "login": "Login",
  "signup": "Signup",
  "register": "Register",
  "registerAsCustomerOrServiceProvider": "Register as a customer or service provider",
  "imACustomer": "I'm a customer",
  "imAServiceProvider": "I'm a service provider",
  "doYouAlreadyHaveAnAccount": "Do you already have an account?",
  "signupToOfferYourServices": "Signup to offer your services",
  "signupAsCustomer": "Signup as a customer",
  "forgottenPassword": "Forgot password",
  "byEmail": "By email",
  "byPhone": "By phone",
  "enterEmail": "Enter your email address",
  "continue": "Continue",
  "enterOtp": "Enter the OTP code",
  "otpSent": "We have sent an OTP code to",
  "didNotReceiveCode": "Didn’t receive the code?",
  "tryAgain": "Try again",
  "errorIncorrectCode": "Error: Incorrect verification code",
  "send": "Send",
  "sendProposalToClient": "Send proposal to client",
  "didNotReceiveEmail": "Didn’t receive the email?",
  "retryIn": "Try again in",
  "firstName": "First name",
  "lastName": "Last name",
  "phone": "Phone",
  "email": "Email",
  "repeatPassword": "Repeat password",
  "areYouIndividualOrCompany": "Are you an individual or a company?",
  "select": "Select",
  "company": "Company",
  "individual": "Individual",
  "serviceCategory": "Service category",
  "selectCategory": "Select category",
  "homeCarePets": "Home\nCare\nPets",
  "selectServices": "Select one or more services",
  "service": "Service",
  "services": "Services",
  "StripeOnboardingInComplete":"Stripe Onboarding Required",
  "YoourStripeOnboardingInComplete":"Your Stripe onboarding is incomplete.",
  "CompleteOnboarding":"Please complete the onboarding process to accept jobs and receive payments.",
  "close":"Close",
  "serviceListHome": "Plumbing\nElectricity\nCleaning\nGardening\nPainting\nRepairs (Handyman)\nPest control\nRoof maintenance\nAir conditioning maintenance\nMoving and transportation",
  "serviceListCare": "Senior caregivers\nBaby caregivers\nTutoring\nOther",
  "serviceListPets": "Bathing and grooming\nPet care at home\nTemporary pet boarding\nOther",
  "regions": "Regions",
  "availability": "Availability",
  "selectAvailability": "Select availability",
  "mondayToFriday": "Monday to Friday",
  "saturdayToSunday": "Saturday to Sunday",
  "allDays": "Every day",
  "alreadyHaveAccount": "Already have an account?",
  "message": "Message",
  "profileDetails": "Profile details",
  "sendProposal": "Submit Proposal",
  "ratingsAndReviews": "Customer reviews",
  "ratingsAndReviewsSubtitle": "Services completed and verified in jandi",
  "reviews": "Reviews",
  "description": "Description",
  "myProfile": "My profile",
  "dashboard": "Dashboard",
  "settings": "Settings",
  "logout": "Logout",
  "myProposals": "My jobs",
  "providerMyProposals": "My Proposals",
  "providerMyProposalsNote": "Proposals you submitted for client quote requests.",
  "submittedDate": "Submitted date",
  "providerRequestQuotes": "Request Quotes",
  "providerRequestQuotesNote": "Quotes clients sent to you. Open one to create or update your proposal.",
  "requestedDate": "Requested date",
  "providerRequestQuoteDetail": "Quote request",
  "noProviderRequestQuotesYet": "No request quotes in your inbox yet.",
  "noProviderProposalsYet": "You have not submitted any proposals yet.",
  "proposalStatus_awaiting": "Awaiting",
  "proposalStatus_submitted": "Submitted",
  "proposalStatus_accepted": "Accepted",
  "proposalStatus_rejected": "Rejected",
  "proposalStatus_converted": "Converted",
  "create_proposal": "Create proposal",
  "edit_proposal": "Edit proposal",
  "submit_proposal": "Submit proposal",
  "proposal_sent": "Proposal saved successfully.",
  "request_quote_proposal_note": "Submit or update your proposal for this quote request.",
  "request_quote_proposal_create_note": "Submit your proposal for this quote request.",
  "openChat": "Open chat",
  "cannotEditProposalForQuote": "You can no longer edit a proposal for this quote.",
  "requestQuotes": "Request Quotes",
  "requestQuotesSubtitle": "Open quote requests waiting for professional proposals.",
  "proposals": "Proposals",
  "unauthorizedProposals": "You are not authorized to view these proposals.",
  "proposal_accepted": "Proposal accepted",
  "submitting": "Submitting…",
  "schedule": "Schedule",
  "submitted": "Submitted",
  "accepted": "Accepted",
  "noRequestQuotesYet": "No open request quotes yet.",
  "awaitingProposals": "Awaiting proposals",
  "chatColumn": "Supplier message",
  "proposedDate": "Proposed date and time",
  "transactionHistory": "Transaction history",
  "adjustments": "Adjustments",
  "messages": "Messages",
  "jobInvitations": "Job invitations",
  "jobInvitation": "Job invitation",
  "paymentHistory": "Payment history",
  "worker": "Worker",
  "client": "Client",
  "clientName": "Client name",
  "hourlyRate": "Hourly rate",
  "totalHours": "Total hours",
  "date": "Date",
  "status": "Status",
  "currentJobStatus": "Current Job Status",
  "disputes": "Disputes",
  "dispute": "Dispute",
  "governmentTax":"Government Tax",
  'Resolve_&_Release_Payment':'Resolve & Release Payment',
  'Resolve_&_refund_payment':'Resolve & refund payment',
  "createDispute": "Create Dispute",
  "reportIt":"I have a problem — report it",
  "confirmStatus":"Service confirmed — your provider is aware",
  "disputeDetails": "Dispute Details",
  "issueType": "Issue Type",
  "paymentIssue": "Payment Issue",
  "workQuality": "Work Quality",
  "behavior": "Behavior",
  "delayedPayout": "Delayed payout",
  "other": "Other",
  "disputeDescription": "Description",
  "disputeDescriptionPlaceholder": "Please describe the issue in detail...",
  "uploadImages": "Upload Images",
  "maxImages": "Maximum 5 images",
  "submitDispute": "Submit Dispute",
  "disputeCreated": "Dispute created successfully",
  "disputeError": "Error creating dispute",
  "activeDisputeExists": "An active dispute already exists for this job. Please wait for resolution.",
  "disputeNotAllowed": "You can only create a dispute for jobs that have started.",
  "unauthorizedDispute": "Only the job owner or assigned worker can create a dispute.",
  "disputeStatus": "Dispute Status",
  "open": "Open",
  "underReview": "Under Review",
  "resolved": "Resolved",
  "closed": "Closed",
  "resolutionNotes": "Resolution Notes",
  "updateStatus": "Update Status",
  "disputeUpdated": "Dispute status updated successfully",
  "noDisputes": "No disputes found",
  "filterByStatus": "Filter by Status",
  "searchByJob": "Search by Job",
  "createdBy": "Created By",
  "jobTitle": "Job Title",
  "jobId": "Job ID",
  "createdDate": "Created Date",
  "viewDispute": "View Dispute",
  "all": "All",
  "pending": "Pending",
  "waitingForPayment": "The customer made the payment",
  "accept": "Accept",
  "accept&pay":"Accept the offer and pay",
  "reject": "Decline proposal",
  "confirmAccept": "Are you sure you want to accept?",
  "confirmReject": "Are you sure you want to reject?",
  "thisActionCannotBeUndone": "This action cannot be undone.",
  "no": "No",
  "yes": "Yes",
  "attachment": "Attachment",
  "arrivalLocation": "Arrival location",
  "noAttachments": "No attachments",
  "viewInvitation": "View invitation",
  "paymentType": "Payment type",
  "billingModel": "Billing",
  "fixedPrice": "Fixed price",
  "hourlyBreakdown": "${{rate}}/hr × {{hours}}h",
  "clientPaymentMethodLabel": "You paid with",
  "workerPaymentMethodLabel": "Provider receives via",
  "workerReceivesVia": "You receive via",
  "clientPaymentStatus": "Payment status",
  "paymentStatus_unpaid": "Unpaid",
  "paymentStatus_pending": "Pending",
  "paymentStatus_confirmed": "Confirmed",
  "athPaymentPendingMessage": "Complete your payment in the ATH Móvil app to confirm this service.",
  "payoutDelayedMessage": "Job completed. Provider payout may be delayed until platform balance is available.",
  "paymentFlow": "Payment flow",
  "totalAmount": "Total amount",
  "markAsOnWay": "Mark as on the way",
  "refund": "Refund",
  "startJob": "Start job",
  "confirmed": "Confirmed",
  "onTheWay": "On the way to service",
  "autoArrivalDetected": "You've arrived at the job site. Status updated automatically.",
  "waitingForProviderArrival": "Provider is on the way — arrival is usually confirmed automatically",
  "distanceToJob": "{{distance}} away",
  "confirmArrivalManually": "Confirm arrival manually",
  "arrivalGpsUnavailable": "Could not confirm arrival. Check location permissions or try again.",
  "autoArrivalEnabled": "Arrival will be detected automatically when you're within range",
  "gettingYourLocation": "Getting your location…",

   'clientwait':"Awaiting client response",
  "markAsArrived": "Mark as arrived",
  "areYouSureMarkAsReached": "Are you sure you want to mark as reached?",
  "arrivedWaitingConfirmation": "Arrived - waiting for client confirmation",
  "inProgress": "In progress",
  "serviceInProgress": "Service in progress",
  "workCompleted": "Job finished - waiting for payment release",
  "transactionId": "Transaction ID",
  "amount": "Amount",
  "backToLogin": "Back to Login",
  "PasswordDontMatch": "Password don't match",
  "toastValidPhone": "Please enter a valid phone number.",
  "toastValidEmail": "Please enter a valid email address.",
  "toastSelectRegionMunicipality": "Please select at least one region/municipality.",
  "toastPasswordMin6": "Password must be at least 6 characters.",
  "toastPasswordStrongRequirements": "Password must be at least 6 characters and include an uppercase letter, a lowercase letter, a number, and a special character (!@#$%^&*).",
  "toastRegisterUserError": "Error registering user. Please try again.",
  "toastCustomServiceCreateFailed": "Could not create custom service.",
  "toastServiceCategoryCreateFailed": "Could not create category for service.",
  "toastServiceOrCategoryCreateError": "Error creating custom service or category.",
  "toastUnverifiedEmail": "You are not verified yet. Please verify yourself via email first.",
  "toastProfileUnderValidation": "Your profile is under validation; we will notify you when it is active - if you have any questions, contact us.",
  "toastLoginSuccessful": "Login successful",
  "toastLoginSuccessfully": "Login successfully",
  "toastLogoutSuccess": "You have successfully logged out.",
  "workDetails": "Job details",
  "noDataFound": "No data found",
  "certifications": "Certifications",
  "certificationsInstructionTitle": "🛡️ Documentation required for validation",
  "certificationsInstructionItem1": "Certificate of Good Conduct (required)",
  "certificationsInstructionItem2": "Valid official ID (required)",
  "certificationsInstructionItem3": "Licenses/certifications (if applicable)",
  "certificationsInstructionPdfLimit": "PDF · Max 1MB per file",
  "certificationsInstructionApproval": "Your profile will not be approved until you complete this section.",
  "certificationsDisclaimer": "Uploaded documents are used only for internal validation and are not visible publicly.",
  "skillsAndServices": "Skills and services",
  "regionAndService": "Region and Service",
  "regionAndServices": "Region and Services",
  "profilePhoto": "Profile photo",
  "uploadPhotoInstruction": "Click on the image to upload a new profile picture <br/> Maximum file size: 10 MB",
  "personalInfo": "Personal information",
  "phoneNumber": "Phone number",
  "hourlyRateUsd": "Hourly rate (USD)",
  "cityLocation": "City/Location",
  "physicalAddress": "Physical address",
  "addressInfoOptional": "Additional address information (optional)",
  "addressNumberEtc": "Address, number, etc.",
  "postalCode": "Postal code",
  "poBoxOrFullAddress": "P.O. box or full address",
  "payment": "Payment",
  "receivePaymentsVia": "Receive payments via",
  "paymentTypeStripe": "Stripe",
  "paymentTypeAth": "ATH",
  "athPhoneNumberLabel": "ATH phone number",
  "selectPaymentType": "Select payment type",
  "choosePaymentMethod": "Choose how you want to pay",
  "athPaymentRequest": "ATH payment request",
  "athEnterPhoneNumber": "Enter the phone number to send the ATH payment authorization request",
  "athPhonePlaceholder": "e.g. 5613305493",
  "stripeSwitchWarningTitle": "Switching to Stripe",
  "stripeSwitchWarningHeading": "Stripe onboarding required",
  "stripeSwitchWarningMessage": "To receive payments through Stripe, you must complete Stripe onboarding. You can start this from the Stripe Onboarding option in the sidebar. You may save this change now, but payouts will only work after onboarding is complete.",
  "athPhoneInvalid": "Please enter a valid phone number",
  "athPhoneNotAthAccount": "This phone number is not registered with ATH Móvil",
  "enterDescription": "Enter your description",
  "about": "About",
  "description/about": "Description/About",
  "updateProfile": "Update profile",
  "ageConfirmationCheckboxLabel": "I confirm that I am 18 years of age or older and that I meet the legal requirements to offer services through JANDI.",
  "ageConfirmationRequired": "You must confirm that you are 18 or older to update your profile.",
  "changePassword": "Change password",
  "currentPassword": "Current password",
  "newPassword": "New password",
  "confirmPassword": "Confirm password",
  "enterCurrentPassword": "Enter your current password",
  "enterNewPassword": "Enter your new password",
  "confirmNewPassword": "Confirm your new password",
  "save": "Save",
  "uploadLimit": "Max size: 1MB, Extensions: .pdf",
  "uploadCertificate": "Upload certificate",
  "uploadDocument": "Upload document",
  "pleaseSelectPdf": "Please select a PDF file to upload.",
  "deleteCertificationConfirmTitle": "Delete document",
  "deleteCertificationConfirmMessage": "Are you sure you want to delete this document? This action cannot be undone.",
  "certificationDeleted": "Document deleted successfully.",
  "myCertifications": "My certifications",
  "completeYourProfile": "Complete Your Profile",
  "completeClientProfileMessage": "Please provide your phone number to continue.",
  "completeWorkerProfileMessage": "Please provide your phone number to continue.",
  "pleaseEnterValidPhone": "Please enter a valid phone number",
  "pleaseSelectServiceCategory": "Please select a service category",
  "profileUpdatedSuccessfully": "Profile updated successfully",
  "EssentialCompletedSuccessfully":"Essential details updated successfully",
  "errorUpdatingProfile": "Error updating profile. Please try again.",
  "updating": "Updating...",
  "continue": "Continue",
  "completeProfileMessage": "Please complete your City, Services, Regions, and Description in the \"Region and Services\" tab to access all settings.",
  "profileIncomplete": "Profile Incomplete,please complete your profile in order to show it to the clients",
  "missingFieldsMessage": "The following required fields are missing:",
  "actions": "Actions",
  "certification": "Certification",
  "document": "Document",
  "skills": "Skills",
  "noMessagesYet": "No messages yet",
  "startConversation": "Start a conversation by sending a proposal or responding to a job invitation.",
  "startAConversation": "Start a conversation",
  "writeAMessage": "Write a message...",
  "sendMessageToUser": "Send a message to",
  "startChating":"to start chatting.",
  "sentAgo": "Sent",
  "second": "Second",
  "minute": "Minute",
  "hour": "Hour",
  "day": "Day",
  "seconds": "Seconds",
  "minutes": "Minutes",
  "hours": "Hours",
  "days": "Days",
  "justNow": "Just now",
  "pay_now": "Pay now",
  "payment_summary": "Confirm and pay",
  "job_details": "Job details",
  "service_provider": "Proposal of",
  "service_name": "Service",
  "date": "Agreed date",
  "status": "Status",
  "awaiting_payment": "Awaiting payment",
  "payment_breakdown": "Payment breakdown",
  "budget": "Your quote",
  "platform_fee": "Platform fee",
  "stripe_fee": "Stripe fee",

  "baseAmount": "Base Amount",
  "commissionRate": "Commission Rate",
  "commissionAmount": "Commission Amount",
  "youWillReceive": "You Will Receive",
  "confirmYourService": "Confirm your service",
  "serviceAmount": "Service Amount",
  "experienceUpgrade": "Experience Upgrade",
  "businessGrowthUpgrade": "Business Growth Upgrade",
  "totalToPay": "Total to pay",
  "yourGuaranteedEarnings": "Your Guaranteed Earnings",
  "clientConfirmDescription": "Your request includes an Experience Upgrade, providing a fast, secure, and centralized way to connect with verified professionals through Jandi.",
  "providerConfirmDescription": "This job includes a Business Growth Upgrade, strengthening your operational tools, secure payments, and visibility, helping you attract more clients and grow your business.",
  "clientConfirmFooter": "This upgrade enhances your safety, convenience, and overall experience.",
  "clientConfirmVoucherNote": "At payment, you can enter a voucher code. Any discount applies only to the Experience Upgrade (service charge), not to the service amount paid to the provider.",
  "providerConfirmFooter": "This upgrade supports your growth, reduces risks, and allows you to focus on your work.",
  "confirmService": "Confirm service",
  "submitProposal": "Submit proposal",
  'quoteRequestSent': 'Quote Request Sent Successfully',
  "total_charge": "Total charge",
  "transparent_fees_note": "All fees are transparent and clearly shown",
  "voucher_code": "Voucher code",
  "apply_voucher": "Apply",
  "clear_voucher_code": "Clear code",
  "voucher_discount": "Discount",
  "voucher_invalid": "Invalid voucher code",
  "voucher_apply_help": "Enter a voucher code and click Apply to preview the discounted total. Discount reduces the service charge only.",
  "voucher_apply_required": "Click Apply to preview the voucher total before paying.",
  "voucher_fee_was_now": "Service charge was ${{before}}, now ${{after}} ({{pct}}%)",
  "voucher_will_be_applied": "Voucher {{code}} will be applied on submit",
  "platform_fee_discount_applied": "Platform fee discount applied: ${{amount}}",
  "platform_fee_after_voucher": "Platform fee after voucher: ${{amount}} ({{pct}}%)",
  "my_vouchers": "My vouchers",
  "my_vouchers_intro": "Vouchers assigned to your account by Jandi. Use them when paying or sending a proposal.",
  "my_vouchers_empty": "You have no assigned vouchers yet.",
  "my_vouchers_load_error": "Could not load your vouchers.",
  "my_vouchers_validity": "Valid",
  "my_vouchers_audience": "For",
  "my_vouchers_audience_client": "Clients",
  "my_vouchers_audience_provider": "Providers",
  "my_vouchers_status_active": "Active",
  "my_vouchers_status_inactive": "Inactive",
  "my_vouchers_status_expired": "Expired",
  "my_vouchers_status_upcoming": "Upcoming",
  "my_vouchers_use_assigned": "Your assigned vouchers (tap to apply):",
  "provider_voucher_section_title": "Promo / voucher code (optional)",
  "provider_voucher_help": "Enter a provider voucher code to reduce your platform fee. The code is validated when you submit the proposal.",
  "provider_voucher_help_apply": "Enter budget (or rate × hours), then Apply to validate your voucher and preview the reduced platform fee.",
  "provider_voucher_placeholder": "e.g. PRO10",
  "provider_voucher_need_budget": "Enter your proposal budget (or hourly rate and hours) before applying a voucher.",
  "provider_voucher_reapply_budget": "Budget changed after applying the voucher. Please Apply the code again.",
  "provider_voucher_review_note": "Code {{code}} will be validated on submit. If valid, your platform fee is reduced and your earnings increase.",
  "provider_platform_fee_full": "Platform fee (full)",
  "provider_earnings_before_voucher": "Earnings before voucher",
  "serviceChargeBeforeDiscount": "Service charge before discount",
  "platformFeeBeforeDiscount": "Platform fee before discount",
  "serviceChargeAfterDiscount": "Service charge after discount",
  "platformFeeAfterDiscount": "Platform fee after discount",
  "paymentAuthTitle": "🔐 Payment authorization",
  "paymentAuthDescription": "Your payment is protected. It is only released to the provider once you confirm that the service has been completed.",
  "paymentAuthOnCompletion": "The amount will be authorized now and processed when the service is completed.",
  "close": "Close",
  "confirm_payment": "Confirm and authorize payment",
  "payment_info": "Payment information",
  "postServiceModalTitle": "✅ Did you receive the service?",
  "postServiceModalDescription": "To close the process and release the payment, you must mark the service as completed on the platform.",
  "postServiceModalMarkCompleted": "Mark as completed",
  "postServiceModalReportIssue": "Report issue",
  "provider_will_receive": "The provider will receive",
  "start_work": "Start working",
  "worker_on_the_way": "The worker is on the way",
  "mark_as_arrived": "Mark as arrived",
  "begin_job": "Start job",
  "finish_job": "Finish job",
  "confirm_start_job": "Are you sure you want to start job?",
  "irreversible_action": "This action cannot be undone.",
  "confirm_release_payment": "Are you sure you want to release payment?",
  "view_proposals": "View proposals",
  "clear": "Clear",
  "view_details": "View details",
  "completed": "Completed",
  "enter_proposal_title": "Enter the proposal title",
  "select_payment_type": "Select payment type",
  "hourly": "Hourly",
  "fixed": "Fixed",
  "title": "Title",
  "location": "Location",
  "search_location": "Search for a place",
  "search": "Search",
  "no_options": "No options",
  "select_start_date_time": "When do you need it?",
  "end_date_time": "End date and time",
  "select_end_date_time": "Select end date and time",
  "urgency": "How urgent is it?",
  "low": "Flexible (can wait days)",
  "medium": "This week",
  "high": "Today",
  "upload_or_drag_image": "Attach a photo",
  "enter_total_budget": "Enter the price you would charge for this service",
  "enter_hourly_rate": "Enter your hourly rate (USD)",
  "enter_total_hours": "Enter estimated hours for this job",
  "enter_description": "Briefly describe your proposal",
  "o":"Or",
  "selectLocation": "Select location",
  "dragLocation":"Drag the marker to select the location",
  "saveLocation":"Save location",
  "selectTheChat":"Select a chat to start chatting",
  "chats":"Chats",
  "selectServices": "Select one or more services",
  "selectRegions": "Select one or more regions/municipalities",
  "selectAvailability": "Select availability",
  "enterEmail": "Enter your email",
  "enterMessage": "Write your message here",
  "fixedRate": "Fixed rate",
  "reviewProposalMessage": "Please review your proposal carefully before submitting.",
  "proposalNote": "Once submitted, you will not be able to edit the proposal details, including rates, times, or any other information.",
  "review": "Review",
  "reviewed": "Reviewed",
  "helloJandi": "Hello! I'm Jandi",
  "wantToKnowHow": "Do you want to know how our platform works?",
  "tellUsWhatYouNeed": "Tell us what you need or what you can offer",
  "stepOne": "Whether you are looking for help or want to offer a service, the first step is to tell us what you need or what you know how to do.",
  "findWhatYouNeed": "Find what you need",
  "personalizedOptions": "You will receive personalized options: clients who need your service or professionals ready to help you.",
  "organizeYourService": "Organize your service",
  "organizeDetails": "Agree on schedules, prices, and details. We are here to make everything easy, safe, and clear.",
  "how_it_works_title": "How it works",
  "how_it_works_subtitle": "Find your Jandi, book, and get your home service done without complications.",
  "how_it_works_step_1": "Choose your Jandi by price, experience, and reviews",
  "how_it_works_step_2": "Book for today if you want",
  "how_it_works_step_3": "Chat, pay, and review — all in one place",
  "electrician": "Electrician",
  "handyman": "Handyman",
  "tutor": "Tutor",
  "caregiver": "Caregiver",
  "groomer": "Groomer",
  "login": "Login",
  "resetPassword": "Reset password",
  "enterNewPassword": "Enter new password",
  "confirmNewPassword": "Confirm new password",
  "confirmPassword": "Confirm password",
  "netAmount":"Net Amount",
  "markOnMyWay": "Mark on the way",
  "payNow": "Pay now",
  "workersConfirmationPending": "Worker`s confirmation pending",
  "markAsReached": "Confirm arrival",
  "connectionStatus": "Connection status",
  "connected": "Connected",
  "reconnecting": "Reconnecting",
  "myStatus": "My status",
  "clientStatus": "Client status",
  "professionalStatus": "Professional status",
  "sharingLocation": "Sharing location",
  "liveLocation": "Live location",
  "disconnected": "Disconnected",
  "notSharingLocations": "Not sharing locations",
  "waitingForLocationData": "Waiting for location data",
  "no": "No",
  "yes": "Yes",
  "rejected":"Rejected",
  "awaitingWorkersAcceptance": "Awaiting worker's acceptance",
  "workerIsOnTheWay": "The provider is en route",
  "finishJob": "Finish Job",
  'CompleteJob':"Complete Job",
  "releaseFunds": "Release funds",
  "jobCompleted": "Job Completed",
  "jobCancelled": "Job Cancelled",
  "jobRejected": "Job Rejected",
  "refunded": "Refunded",
  "awaitingPayment": "Awaiting Payment",
  "reached": "The provider has arrived at the service location",
  "jobFinished": "Job Finished",
  "successfullyCompleted": "The provider marked the job as complete",
  "cancelled": "Cancelled",
  "acceptReject": "Accept/Reject",
  "confirmJob": "Confirm Job",
  "submitForCompletion": "Submit for Completion",
  "applicationRejected": "Application Rejected",
  "applicationWithdrawn": "Application Withdrawn",
  "confirmAction": "Confirm action?",
  "creatingJob":"Creating job...",
  "rateExperience":"How was your experience?",
  "leaveFeedback":"Your review helps other customers choose with confidence.",
  "submitReview":"Submit review",
  "characters": "characters",
  "cancel": "Cancel",
  "write": "Write",
  "other":"Others",
  "legalAgreements":"Legal Agreements",
  "privacyPolicy":"Privacy Policy",
  "termOfUse":"Terms of Use",
  "textMessagePolicy":"Text Message Policy",
  "confimation":"Agree to our",
  "and":"and",
  "smsOptInCheckboxLabel": "I agree to receive automated SMS messages related to my account and services on JANDI. Message frequency varies. Reply STOP to cancel. Message and data rates may apply.",
  "smsOptInHelperText": "SMS messages are used only for service notifications such as requests, chat messages, appointment reminders, status changes, or cancellations.",
  "settingsSmsNotificationsLabel": "Receive SMS notifications",
  "settingsSmsNotificationsHelper": "You can turn this off at any time. Reply STOP to any message to unsubscribe.",
  "settingsSmsNotificationsLabel": "Receive SMS notifications",
  "settingsSmsNotificationsHelper": "You can turn this off at any time. Reply STOP to any message to unsubscribe.",
  "noProposalsYet":"There are no proposals available at the moment.",
  "city": "City",
  "physicalAddress": "Physical address",
  "postalAddress": "Postal address",
  "servicesYouWouldProvide": "Services you would provide",
  "whatCanYouDo": "What can you do? (Select your skills)",
  "enterFullPostalAddress": "Enter your full postal address. You can use a P.O. Box or your residential address. (number + street + city + PR + ZIP)",
  "includeStreetOrHighway": "Include street or highway number if applicable.",
  "continue": "Continue",
  "exampleAddress": "Ex: Highway 123, Km 4.5, Pueblo Neighborhood",
  "streetOrHighwayNumber": "Street or Highway Number (if applicable)",
  "zipCode": "ZIP Code",
  "examplePOBox": "Ex: P.O. Box 1234, San Juan, PR, 00901",
  "uploadLogoIfAny": "If you have a logo, you can upload it here",
  "tellUsAboutService": "Tell us about the service you offer",
  "exampleExperience": "I am a professional with more than 5 years of experience in...",
  "back": "Back",
  "finish": "Finish",
  "loadingServices": "Loading services",
  "requestService": "Request Service",
  "descriptionofRequestedService":"Briefly describe what you need",
  "serviceLocation":"Where do you need the service?",
  "estimatedBudget":"What is your approximate budget?",
  'optional':"Optional",
  "selectBudgetRange":"Select range",
  "mustLoginToSendProposal":"You must login to send request quote.",
  "DateTextHelp":"Indicates a tentative date. You can agree on the final date and time with the provider",
  "budgetHelpText":"The final price is agreed with the supplier before starting.",
  "SVerification":"Successful verification",
  "SVerified":"Your account has been successfully verified.",
  "EVerification":"Verification error",
  "EVerified":"The verification code is invalid or has expired.",
  "signupConfirmation_provider_primaryButton":"Complete my profile",
  "signupConfirmation_provider_title":"Welcome to jandi!",
  "signupConfirmation_provider_intro":"Your request was received. Our team will review your profile within the next 24 to 48 hours. We will notify you when your account is active and ready to receive requests.",
  "signupConfirmation_provider_body":"In the meantime, make sure your profile is complete with a photo and description - that speeds up validation.",
  "signupConfirmation_provider_footer":"Puerto Rico has talent. We want it to stay and always be at hand.",
  "signupConfirmation_client_title":"You are now part of jandi!",
  "signupConfirmation_client_intro":"Your account has been created. Verify your email address, and then you can search for available providers in your area and get what you need—fast, easy, and with support.",
  "selectRoleContinue":"Select your role to continue",
  "workOwnPace":"Work at your own pace. You decide when and how",
  ...whatMovesUsEn,
  ...faqEn,
  ...termOfUseEn,
  ...privacyPolicyEn,
  ...textMessagePolicyEn,
  ...legalAgreementsContactEn,
};